import { DENOMINACIONES, WIZARD_STEPS } from "./constants";
import { FacturaSegmento, GastoItemForm, SucursalRendicion } from "./types";

export const obtenerIndicePaso = (id: string) => WIZARD_STEPS.findIndex((step) => step.id === id);

export const crearMapaDenominaciones = () => {
  const inicial: Record<number, string> = {};
  DENOMINACIONES.forEach((valor) => {
    inicial[valor] = "0";
  });
  return inicial;
};

export const construirClaveSucursal = (registro: SucursalRendicion) =>
  `${registro.idsucursal}-${registro.fuente ?? "default"}`;

export const formatearFacturaSegmento = (segmento?: FacturaSegmento | null) => {
  if (!segmento) {
    return null;
  }
  const { establecimiento, punto, numero } = segmento;
  if (!establecimiento || !punto || !numero) {
    return null;
  }
  const pad = (valor: string, size: number) => valor.trim().padStart(size, "0");
  return `${pad(establecimiento, 3)}-${pad(punto, 3)}-${pad(numero, 7)}`;
};

export const construirIdFacturaInput = (rango: "desde" | "hasta", indice: number) =>
  `factura-${rango}-${indice}`;

export const construirIdFacturaAnulada = (indice: number) => `factura-anulada-${indice}`;

export const crearArticuloGasto = (): GastoItemForm => ({
  descripcion: "",
  codigo: "",
  articulo: "",
  unidad: "UNI",
  cantidad: 0,
  precioUnitario: 0,
  monto: 0,
  iva: 0,
});

export const crearFacturaSegmentoVacio = (): FacturaSegmento => ({
  establecimiento: "",
  punto: "",
  numero: "",
});
